import { render, staticRenderFns } from "./OperatorsAvgTime.vue?vue&type=template&id=6596fe12"
import script from "./OperatorsAvgTime.vue?vue&type=script&lang=js"
export * from "./OperatorsAvgTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports